import { useSelector } from 'react-redux';
import { getCachedMediaUrl } from '../../../../../lib/utils/utils';

function MobileBanner() {
    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);
    const { storefront } = useSelector((state) => state.storefront.storefront);

    return (
        <div className="w-full relative">
            <img className='w-full aspect-square' src={getCachedMediaUrl(versionStack[versionIndex]?.backgroundImage ? versionStack[versionIndex]?.backgroundImage : storefront.BackGround)} alt="" />

            <div className="w-[100px] rounded-full overflow-hidden absolute left-1/2 -translate-x-1/2 -bottom-[50px]">
                <img src={getCachedMediaUrl(storefront.Logo)} alt="" />
            </div>
        </div>
    );
}

export default MobileBanner;
